import axios from 'axios'
import { PAEnvironment } from '../PA.Core/PAEnvironment'
import { IPPACalcService, isPPACalcResponse, PPACalcRequest, PPACalcResponse } from './PPACalcService.IF'

export const ppaCalcServiceEndpoint = 'ppaModelService'

class PPACalcService implements IPPACalcService {
    CalculateMarketShares(req: PPACalcRequest): Promise<PPACalcResponse> {
        console.log(`${new Date().toUTCString()}: Calculating market shares for scenario ${req.WbPPAScenarioId}`)
        return this.makeRequest(req)
    }

    CalculateElasticities(req: PPACalcRequest): Promise<PPACalcResponse> {
        console.log(`${new Date().toUTCString()}: Calculating elasticities for scenario ${req.WbPPAScenarioId}`)
        return this.makeRequest(req)
    }

    private async makeRequest(req: PPACalcRequest): Promise<PPACalcResponse> {
        let sEndPoint = <string>(PAEnvironment.getValue(PAEnvironment.Network_URL_Base), '/')
        if (sEndPoint.endsWith('/')) {
            sEndPoint += ppaCalcServiceEndpoint
        } else {
            sEndPoint += `/${ppaCalcServiceEndpoint}`
        }
        try {
            const resp = await axios.post(sEndPoint, { data: { request: req } })
            if (!isPPACalcResponse(resp.data)) {
                throw new Error('Response from server is not the correct type')
            }
            return resp.data
        } catch (e: unknown) {
            const msg: string = e instanceof Error ? e.message : `An unknown error occurred: ${e}`
            return {
                bSuccess: false,
                sErrors: [msg],
                sWarnings: [],
                sInfo: []
            }
        }
    }
}

/** Creates a new instance of the PPACalcService. This return object is what should be called by the UI's calculation buttons */
export function GetPPACalcService(): IPPACalcService {
    return new PPACalcService()
}
